module.exports = __webpack_public_path__ + "img/exampleItem4.82b5cf1b.png";